module.exports = __webpack_public_path__ + "img/icon66.e24f9945.png";